/* eslint 'no-self-assign' : 'off', eqeqeq: 'off'  */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { FormGroup, Label, Form, Table, Button } from 'reactstrap';
import EditSetting from '../_ModalsForms/EditPreventativeMaintenanceSetup';
import {PreventativeMaintenanceStandardFieldsInitialSetup, GetPreventativeMaintenanceStandardFields,SavePreventativeMaintenanceMailAddresses,GetPreventativeMaintenanceMailAddresses} from '../../../../action/workorderAction';
import { setAmplitudeEvent } from 'amplitude/amplitude';
import PreventativeMaintenanceCustomFields from './PreventativeMaintenanceCustomFields';
import PreventativeMaintenanceTemplates from './PreventativeMaintenanceTemplates';
import AddEditPMCustomFieldSetup from './AddEditPMCustomFieldSetup';
import CreatePMTemplate from './CreatePreventativeMaintenanceTemplate';

const headinglabel = {
    fontfamily: 'Verdana',
    fontSize: '14px',
    fontWeight: 'bold',
    'margin-left':'15px'
};

class PreventativeMaintenanceSetup extends Component {
    constructor(props){
        super(props);
        this.state = {
            sort: {
                column: null,
                direction: [
                    { name: 'field', direction: 'desc', onclick: false },
                    { name: 'fieldLabel', direction: 'desc', onclick: false },
                    { name: 'type', direction: 'desc', onclick: false },
                    { name: 'shortValue', direction: 'desc', onclick: true },
                    { name: 'required', direction: 'desc', onclick: false },
                    { name: 'display', direction: 'desc', onclick: false }
                ]
            },
            Options_List_Value : [],
            IsInitial:false,
            editmodal:false,
            selectedRowId: 0,
            selectedRow:[],
            IsDefaultSort: true,
            isAddEditCustommodal: false,
            isAddEditCustomTemplate: false,
            CustomFieldId : -1,
            templateId : -1,
            IsMailAddressEdit: false,
            MailAddresses: '',
            IsMailError: false
        }
        this.Edittoggle = this.Edittoggle.bind(this);
        this.SaveInitialSetup = this.SaveInitialSetup.bind(this);
        this.AddEditCustomTemplate = this.AddEditCustomTemplate.bind(this);
    }

    componentWillMount() {
        this.props.GetPreventativeMaintenanceStandardFields();
        this.props.GetPreventativeMaintenanceMailAddresses();
    }

    componentWillReceiveProps(nextProps) {
        let label = this.props.getLabels;

        if(this.props !== nextProps && nextProps.getMailAddresses !== undefined){
            this.setState({ MailAddresses : nextProps.getMailAddresses });
        }
        if(this.props !== nextProps && nextProps.AddCustomModal.modal_open !== undefined){
            this.setState({isAddEditCustommodal : nextProps.AddCustomModal.modal_open , CustomFieldId : nextProps.AddCustomModal.CustomFieldId});            
        }

        if(this.props !== nextProps && nextProps.AddTemplateModal !== undefined && nextProps.AddTemplateModal.modal_open !== undefined){
            this.setState({isAddEditCustomTemplate : nextProps.AddTemplateModal.modal_open , templateId : nextProps.AddTemplateModal.templateId});            
        }

        //scroll to top of the page
        var scrollPageTop = (this.props.Premise) ? document.getElementsByClassName('Ensemble_Content_FullPage') : document.getElementsByClassName('Ensemble_Content');
        if(scrollPageTop[0] !== undefined){
            (this.props.Premise) ? scrollPageTop[0].scrollIntoView() : scrollPageTop[0].scrollTop = 0;
        }

        // var Status = label['PreventativeMaintenance.Status.Text'].split(',');
        // var status_values = Status.map((el,i) => ({
        //     key: el,
        //     value: label['PreventativeMaintenance.Status.'+el+'.Text'],
        //     isCustom: false,
        //     orderId: el == 6 ? 999 : i
        // }
        // ));
        // var status_short = status_values.map(el => (
        //     el.value
        // ));
        // var status_short_text = status_short.join(', ').substring(0, 30) + (status_short.join(', ').length > 30 ? "..." : "")

        // var Options = label['PreventativeMaintenance.Options.Text'].split(',');
        // var Options_Value = Options.map(el => (
        //     {
        //         field: label['PreventativeMaintenance.Options.' + el + '.Text'],
        //         fieldLabel: label['PreventativeMaintenance.Options.' + el + '.Text'],
        //         fieldId: el,
        //         type: (el == 1 || el == 2 || el == 4 || el == 5) ? label['WorkOrderSetup.SingleDropdown.Text'] :  (el == 3  || el > 5) ? label['WorkOrderSetup.TextArea.Text'] : "--",
        //         value: el == 1 ? status_values : "--",
        //         shortValue: el == 1 ? status_short_text : "--",
        //         display: true,
        //         required: false
        //     }
        // ));

        if (this.props != nextProps && nextProps.getStandardFields != undefined && nextProps.getStandardFields.length > 0) {

            var fieldsFromDB = nextProps.getStandardFields;
            fieldsFromDB.forEach(fields => {
                fields.fieldLabel = (fields.fieldLabel != "") ? fields.fieldLabel : label['PreventativeMaintenance.Options.' + fields.fieldId + '.Text'];
                if (fields.value.length > 0) {
                    fields.value.forEach(el => {
                        if (fields.fieldId == 1 && el.isCustom == false && el.value == "") {
                            el.value = label['PreventativeMaintenance.Status.' + el.key + '.Text'];
                        }
                    }
                    );
                }
            });

            var setup_values = fieldsFromDB.map(el => ({
                field: el.field,
                fieldLabel: el.fieldLabel,
                fieldId: el.fieldId,
                type: (el.fieldId == 1 || el.fieldId == 2 || el.fieldId == 4 || el.fieldId == 5 || el.fieldId == 11 || el.fieldId == 12) ? label['WorkOrderSetup.SingleDropdown.Text'] :  (el.fieldId == 3  || (el.fieldId > 5 && el.fieldId < 11)) ? label['WorkOrderSetup.TextArea.Text'] : "--",
                value: el.value.length > 0 ? el.value : "--",
                shortValue: "---",
                display: el.display ,
                required: el.required
            }));

            setup_values.forEach(el => {
                if (el.value != "--") {
                    let sortedData = el.value.sort((a, b) => {
                        var nameA = a['orderId'];
                        var nameB = b['orderId'];
                        if (nameA < nameB) { return -1; }
                        if (nameA > nameB) { return 1; }
                        if (nameA == nameB) { return 0; }
                        return 0;
                    });
                    var short_text = sortedData.map(el => (
                        el.value
                    ));
                    el.shortValue = short_text.join(', ').substring(0, 30) + (short_text.join(', ').length > 30 ? "..." : "")
                }
            });

            const array = this.state.sort.direction;
            array.map(x => (x.name == 'shortValue') ? x.onclick = true : x.onclick = false);
            array.map(x => x.direction = 'desc');

            this.setState({ Options_List_Value: setup_values,IsInitial:false,sort:{column:null,direction:array}});
        }
        // else{

        // this.setState({ Options_List_Value: Options_Value,IsInitial:true }); 
        // }
        
    }

    Edittoggle() {
        this.setState({
            editmodal: !this.state.editmodal
        });
    }

    AddEditCustomtoggle  = value => {
        this.setState({isAddEditCustommodal : value});
    }

    AddEditCustomTemplate = value => {
        this.setState({
            isAddEditCustomTemplate: value
        })
    }

    async SaveInitialSetup() {
        var l_InitialSetup = [];

        this.state.Options_List_Value.forEach(element => {
            var l_value = [];
            if (element.value != "--") {
                element.value.forEach(el => {
                    l_value.push(el)
                });
            }

            var lineItem = {
                "field": element.field,
                "fieldLabel": element.fieldLabel,
                "fieldId": element.fieldId,
                "value": l_value,
                "display": element.display,
                "required": element.required,
            }
            l_InitialSetup.push(lineItem);
        });

        await this.props.PreventativeMaintenanceStandardFieldsInitialSetup(l_InitialSetup);
    }

    EditSetup(e) {

        var l_row = this.state.Options_List_Value.filter(x => x.fieldId == e)[0];
        var l_rowValue = [];
        if (l_row.value != "--") {
            l_rowValue = l_row.value.map((el, i) => ({
                key: el.key,
                value: el.value,
                isCustom: el.isCustom,
                index: i,
                orderId:el.orderId
            }));
            l_row.value = l_rowValue;
        }
        this.setState({
            selectedRowId: e,
            selectedRow: l_row
        });
        this.Edittoggle();
    }

    onSort = (column) => (e) => {
        this.setState({IsDefaultSort: false});
        const SelectedDirectioninfo = this.state.sort.direction.filter(x => x.name == column)[0];
        const direction = SelectedDirectioninfo !== null ? (SelectedDirectioninfo.direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.state.Options_List_Value;
        var notequals = 0;

       if(data_from_state != null){
        const sortedData = this.state.Options_List_Value.sort((a, b) => {
            var nameA = a[column];
            var nameB = b[column];

            if (isNaN(a[column])) {
                nameA = a[column].toLowerCase();
                nameB = b[column].toLowerCase();
            }
            if (nameA < nameB) {
                notequals = 1;
                return -1;
            }
            if (nameA > nameB) {
                notequals = 1;
                return 1;
            }
            if (nameA == nameB) {
                return 0;
            }
            return 0;
        });

        if(SelectedDirectioninfo.direction == 'asc' && notequals == 1){
        sortedData.reverse();
     }

     const array = this.state.sort.direction;
     array.map(x => (x.name == column) ? x.onclick = true : x.onclick = false);
     array.map(x => (x.name == column) ? x.direction = direction : x.direction = x.direction);

        this.setState({
            temp_adjustments_list_state: sortedData,
            sort: {
                column,
                direction: array,
            }
        });
       }
    };

    OnCancelMailSetup = () =>{
        this.setState({ IsMailAddressEdit : false })
    }

    OnAddEmailAddress = () =>{
        this.setState({ IsMailAddressEdit : true, IsMailError : false })
    }

    OnSaveEmailAddress = () =>{
        this.setState({ IsMailError : false });
        var l_MailAddresses = this.refs.txt_Setup_MailAddress.value.trim();

        var IsValid = true;
        let Email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var EmailIds = this.refs.txt_Setup_MailAddress.value; 
        var Ids = EmailIds.trim().toLowerCase().split(/\s*;\s*/);
        for(let i=0; i<Ids.length; i++){
            var MailId = Ids[i];
            if(MailId !== "" && !MailId.match(Email)){
                IsValid = false;
            }
        }
        if(IsValid){
            const uniqueMailIds = Ids.filter((val,id,array) => array.indexOf(val) === id).filter(val => val !== "")
            setAmplitudeEvent("WO/PM Email Notifications",{"PM Emails":uniqueMailIds.length});
            this.props.SavePreventativeMaintenanceMailAddresses({"MailAddress" : l_MailAddresses});
            this.setState({ IsMailAddressEdit : false })
        }
        else{
            this.setState({ IsMailError : true });
        }
    }

    render(){
        let label = this.props.getLabels;


        if(this.state.Options_List_Value !== undefined && this.state.Options_List_Value !== null && this.state.Options_List_Value.length && this.state.IsDefaultSort){
           //eslint-disable-next-line
            const sortedData = this.state.Options_List_Value.sort((a, b) => {
                var nameA = a['shortValue'];
                var nameB = b['shortValue'];
    
                if (isNaN(a['shortValue'])) {
                    nameA = a['shortValue'].toLowerCase();
                    nameB = b['shortValue'].toLowerCase();
                }
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });
        }
        var data = this.state.Options_List_Value.map(el => (
            <tr key={el.fieldId} id={el.fieldId}>
                <td><Label className="link_cursorUnderline" onClick={() => {this.EditSetup(el.fieldId)}} >{label['PreventativeMaintenance.Options.'+el.fieldId+'.Text']}</Label></td>
                <td>{el.field != el.fieldLabel ? el.fieldLabel : el.field}</td>
                <td>{el.type}</td>
                <td>{el.shortValue}</td>
                <td>{el.required ? label['WorkOrderSetup.Yes.Text'] : label['WorkOrderSetup.No.Text']}</td>
                <td>{ el.display == true ? label['WorkOrderSetup.Yes.Text'] : label['WorkOrderSetup.No.Text']}</td>
            </tr>
        ));

        return(
            <div className= {this.props.Premise ? "main_container" : "cloud_main_container"}>
            <div className="border_container">
              <div className="main_container">
                 {   this.state.isAddEditCustomTemplate ? <CreatePMTemplate Premise={this.props.Premise} TemplateId={this.state.templateId} Equipment={false} Page='Administrative PM Page'/> :
                     this.state.isAddEditCustommodal ? <AddEditPMCustomFieldSetup CustomFieldId={this.state.CustomFieldId}  AddEditCustomtoggle={this.AddEditCustomtoggle} Premise={this.props.Premise}/> : 
                     this.state.editmodal == false ? 
                <div>
                    <div className="div_Setup_Email">
                    {
                        this.state.IsMailAddressEdit ?
                        <p>
                            <Label className="LblHeader_Setup_Email">Preventative Maintenance Email Notifications</Label>
                            <Button className="btn_Setup_Action_Email_success" style={{"background": "rgb(76, 145, 45)"}} onClick={this.OnSaveEmailAddress}>Save</Button>
                            <Button className="btn_Setup_Action_Email_cancel" style={{"margin-right":"7px"}} onClick={this.OnCancelMailSetup}>Cancel</Button>
                            <br/>
                            <Label className="Lbltitle_Setup_Email">Send email notification for every Preventative Maintenance that is created and closed.</Label>
                            <Label className="lbl_subtitle_Setup_Email">Email</Label><span className="span_Setup_Email"> (opt.)</span>
                            <textarea className={!this.state.IsMailError ? "textarea_Setup_Email" : "textarea_Setup_Email textarea_Setup_EmailError"} ref="txt_Setup_MailAddress" defaultValue={this.state.MailAddresses} />
                            <span className="span_Setup_EmailNotification">Type additional addresses using semi-colons to separate each address.</span>
                        </p> : (this.state.MailAddresses !== "" && this.state.MailAddresses !== null) ? 
                        <p>
                            <Label className="LblHeader_Setup_Email">Preventative Maintenance Email Notifications</Label>
                            <Button className="btn_Setup_Email" onClick={this.OnAddEmailAddress}>Edit</Button>
                            <br/>
                            <Label className="Lbltitle_Setup_Email">Send email notification for every Preventative Maintenance that is created and closed.</Label>
                            <Label className="lbl_Setup_SavedEmailHeader">Email</Label><br/>
                            <Label className="lbl_Setup_SavedEmail">{this.state.MailAddresses}</Label>
                        </p> :
                        <p>
                            <Label className="LblHeader_Setup_Email">Preventative Maintenance Email Notifications</Label>
                            <Button className="btn_Setup_Email" onClick={this.OnAddEmailAddress}>Add Email</Button>
                            <br/>
                            <Label className="Lbltitle_Setup_Email">Send email notification for every Preventative Maintenance that is created and closed.</Label>
                        </p>
                    }  
                    </div>
                <Form>
                    <FormGroup style={{"margin-bottom":"0px"}}>
                        <Label style={headinglabel} id="PageHeader">{label['WorkOrderSetup.StandardField.Text']}</Label>
                    </FormGroup>
                    <FormGroup>
                        <Label id="UAText" style={{'margin-left':'15px'}}>{label['PMSetup.UIText.Text']}</Label>
                    </FormGroup>
                </Form>
                
                <div className="table_container table_border">
                    <Table striped responsive className=" Custom_table fixed_layout" id="tblStandardField">
                        <tbody  className="cell_container">
                            <tr>
                                <th className="wo_cursor" onClick={this.onSort('field')} >
                                    <span>{label['WorkOrderSetup.Header.FieldName.Text']}</span>
                                            <span className={(this.state.sort.direction[0].name == "field") ?
                                                (this.state.sort.direction[0].onclick) ? (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                    : (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th className="wo_cursor" onClick={this.onSort('fieldLabel')} >
                                <span>{label['WorkOrderSetup.Header.FieldLabel.Text']}</span>
                                            <span className={(this.state.sort.direction[1].name == "fieldLabel") ?
                                                (this.state.sort.direction[1].onclick) ? (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                    : (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>                              
                                </th>
                                <th className="wo_cursor" onClick={this.onSort('type')} >
                                <span>{label['WorkOrderSetup.Header.FieldType.Text']}</span>
                                            <span className={(this.state.sort.direction[2].name == "type") ?
                                                (this.state.sort.direction[2].onclick) ? (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                    : (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th className="wo_cursor" onClick={this.onSort('shortValue')}>
                                <span>{label['WorkOrderSetup.Header.Values.Text']}</span>
                                            <span className={(this.state.sort.direction[3].name == "shortValue") ?
                                                (this.state.sort.direction[3].onclick) ? (this.state.sort.direction[3].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                    : (this.state.sort.direction[3].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span></th>
                                <th className="wo_cursor" onClick={this.onSort('required')} >
                                <span>{label['WorkOrderSetup.Header.Required.Text']}</span>
                                            <span className={(this.state.sort.direction[4].name == "required") ?
                                                (this.state.sort.direction[4].onclick) ? (this.state.sort.direction[4].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                    : (this.state.sort.direction[4].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th className="wo_cursor" onClick={this.onSort('display')} >
                                <span>{label['WorkOrderSetup.Header.DisplayOnPage.Text']}</span>
                                            <span className={(this.state.sort.direction[5].name == "display") ?
                                                (this.state.sort.direction[5].onclick) ? (this.state.sort.direction[5].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                    : (this.state.sort.direction[5].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                            </tr>
                            {data}
                        </tbody>
                    </Table>
                </div>
                <PreventativeMaintenanceCustomFields AddEditCustomtoggle={this.AddEditCustomtoggle}/>
                <PreventativeMaintenanceTemplates ToggleTemplate={this.AddEditCustomTemplate} />
                {/* <div style={{marginTop: '30px'}}>
                    <Form>
                        <FormGroup>
                            <Label style={headinglabel}>Preventative Maintenance Templates</Label>
                            <Button style={{'float':'right'}} className="child_tab_button" onClick={() => this.AddEditCustomTemplate(true)}>CREATE MAINTENANCE TEMPLATE</Button>
                        </FormGroup>
                    </Form>
                </div> */}
            </div> 
             : <EditSetting id={this.state.selectedRowId} values={JSON.stringify(this.state.selectedRow)} close={this.Edittoggle} isInitialSetup={this.state.IsInitial} fromWorkOrder={false} SaveInitial={this.SaveInitialSetup} Premise={this.props.Premise}/>
             }
            </div>
            </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getStandardFields : state.WorkorderRootReducer.PreventativeMaintenanceStandardFields,
        AddCustomModal : state.WorkorderRootReducer.AddCutomModalOpenClose ,
        AddTemplateModal : state.WorkorderRootReducer.AddTemplateModalOpenClose,
        getMailAddresses : state.WorkorderRootReducer.PreventativeMaintenanceSetupMailAddresses
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetPreventativeMaintenanceStandardFields : () => dispatch(GetPreventativeMaintenanceStandardFields()),
        PreventativeMaintenanceStandardFieldsInitialSetup : (data) => dispatch(PreventativeMaintenanceStandardFieldsInitialSetup(data)),
        SavePreventativeMaintenanceMailAddresses: (data) => dispatch(SavePreventativeMaintenanceMailAddresses(data)),
        GetPreventativeMaintenanceMailAddresses : () => dispatch(GetPreventativeMaintenanceMailAddresses())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PreventativeMaintenanceSetup);